import { useMutation, useQueryClient } from '@tanstack/react-query';

import createLeadReferral, {
  CreateLeadReferralApiPayload,
  LeadReferralResponse,
} from '@/actions/leads/createLeadReferral';
import { ApiResponse } from '@/types/response.type';

export interface UseCreateLeadReferralReturn {
  mutate: (
    payload: CreateLeadReferralApiPayload
  ) => Promise<ApiResponse<LeadReferralResponse> | undefined>;
  result: ApiResponse<LeadReferralResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateLeadReferral = (): UseCreateLeadReferralReturn => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: createLeadReferral,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consultant-leads'] });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
